// Canonical depletions product names are long / truncated in the DB
// (e.g. "Hooten Young Bottled in B", "Hooten Young 12 Year Amer"). This
// condenses them to short, readable chip labels used across the
// depletions surfaces (Premises Mix drill-down, 2026 Orders, etc.).
export function shortProductLabel(name: string): string {
  const n = name.toLowerCase();
  if (n.includes('12 year')) return '12yr';
  if (n.includes('15 year')) return '15yr';
  if (n.includes('jack carr') || n.includes('16')) return 'Jack Carr';
  if (n.includes('8 year') || n.includes('8yr')) return '8yr';
  if (n.includes('bottled in b') || n.includes('bib')) return 'Bourbon';
  if (n.includes('single barrel') || n.includes('sngl brrl')) return 'Single Barrel';
  if (n.includes('constitution') || n.includes('hull')) return 'Hull Reserve';
  if (n.includes('rye')) return 'Rye';
  if (n.includes('cabernet')) return 'Cabernet';
  if (n.includes('petite sirah')) return 'Petite Sirah';
  if (n.includes('zinfandel')) return 'Zinfandel';
  return (
    name
      .replace(/^Hooten Young\s*-?\s*/i, '')
      .replace(/\s*\d+\s*ml.*$/i, '')
      .trim() || name
  );
}
